

















































































































































































import { Vue, Component } from 'vue-property-decorator';
import IconSvg from './components/IconSvg.vue';
import TrendChart from './components/TrendChart.vue';
import BarChart from './components/BarChart.vue';
import ScrollBoard from './components/ScrollBoard.vue';
import * as api from '@/api';
import moment, { Moment } from 'moment';

@Component({
  components: { IconSvg, TrendChart, BarChart, ScrollBoard },
})
export default class DataViews extends Vue {
  // data
  currentTime: string = new Date().toLocaleTimeString();
  currentDate: string = '';
  currentDayOfWeek: string = '';
  currentNav: string = 'dataViewIndex';
  timer: number | null = null;
  paramType = '';
  tableData = [];
  dateValues = this.getLast30DaysRangeArray();
  frontTotalCount = 0;
  negativeTotalCount = 0;
  frontData = [];
  negativeData = [];
  toDayData = [];

  sentimentCards = [
    { label: '正面报道', value: 4533 },
    { label: '网络舆情', value: 4533 },
    { label: '今日舆情', value: 4533 },
  ];

  // computed
  get scale(): number {
    const el = this.$refs.dashboardRef as HTMLElement;
    if (!el) return 1;
    const containerWidth = el.clientWidth;
    return containerWidth / (containerWidth * 1); // 占位逻辑
  }

  getLast30DaysRangeArray(): [Moment, Moment] {
    const end = moment().endOf('day'); // 今天 23:59:59
    const start = moment()
      .subtract(30, 'days')
      .startOf('day'); // 30天前 00:00:00
    return [start, end];
  }

  // methods
  updateTime(): void {
    this.currentTime = new Date().toLocaleTimeString();
  }

  switchWeek(type: string) {
    // this.$refs.trendChartRef.setTypeAndFetch(type);
    (this.$refs.trendChartRef as InstanceType<typeof TrendChart>).setTypeAndFetch(type);
  }

  typeSwitchWeek(type: string) {
    // this.$refs.trendChartRef.setTypeAndFetch(type);
    (this.$refs.barChartRef as InstanceType<typeof TrendChart>).setTypeAndFetch(type);
  }

  updateDateInfo(): void {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    const day = now.getDate();
    const dayOfWeek = now.toLocaleDateString('zh-CN', { weekday: 'long' });

    this.currentDate = `${year}-${month}-${day}`;
    this.currentDayOfWeek = dayOfWeek;
  }

  async vViewFullDirective(): Promise<void> {
    await this.$nextTick();
    const el = this.$refs.dashboardRef as HTMLElement;
    if (!el) return;

    const sWidth = document.body.clientWidth;
    const sW = sWidth / 1920;
    el.style.transform = `scale(${sW})`;
    el.style.transformOrigin = `0px 0px`;
  }

  navClick(item: { key: string }): void {
    this.currentNav = item.key;
    this.$router.push({ name: item.key });
  }

  async getAppYqData(isPositive: boolean) {
    const data: any = await api.Yq.getAll_GET({
      isPositive: isPositive,
      reportState: null,
      eventCategoryId: null,
      keyword: '',
      theme: '',
      publisher: '',
      source: '',
      startPublishTime: null,
      endPublishTime: null,
      startCreationTime: null,
      endCreationTime: null,
      size: 100,
      p: 1,
    });

    if (isPositive) {
      this.frontData = data.data.Items;
      this.frontTotalCount = data.data.TotalCount;
    } else {
      this.negativeData = data.data.Items;
      this.negativeTotalCount = data.data.TotalCount;
    }
  }

  async getToDayData() {
    const data: any = await api.Yq.getToday_GET({
      eventCategoryId: '',
      keyword: '',
      theme: '',
      publisher: '',
      source: '',
      city: '',
    });
    this.toDayData = data.data;
  }

  // lifecycle
  mounted() {
    this.vViewFullDirective();
    window.addEventListener('resize', this.vViewFullDirective);

    this.timer = window.setInterval(this.updateTime, 1000);
    this.updateDateInfo();

    this.$nextTick(() => {
      this.currentNav = this.$route.name || 'dataViewIndex';
    });

    // this.getNewestYq();
    this.getAppYqData(true);
    this.getAppYqData(false);
    this.getToDayData();
  }

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    window.removeEventListener('resize', this.vViewFullDirective);
  }
}
